import { env } from '@/constants';
import { useAuthenticationStore } from '@/stores/authentication/AuthenticationStore';
import { sharedRoutes } from '@/shared-routes';
import { urlWithRedirect } from '@/utils/urlUtils';
import { AmplitudeFeatureFlagService } from '@/services/feature/providers/AmplitudeFeatureFlagService';
import type { AuthToken, HttpServiceConfiguration } from '@arcual/lib-app-platform';

export class PlatformHttpServiceConfiguration implements HttpServiceConfiguration {
  public authTokenKey(): string {
    return env.VITE_AUTH_TOKEN_KEY;
  }

  public corsProxy(): string {
    return env.VITE_CORS_PROXY;
  }

  public restEndpoint(): string {
    return env.VITE_PLATFORM_REST_ENDPOINT;
  }

  public redirectToLogin(): void {
    if (
      global.location.pathname &&
      global.location.pathname.indexOf(sharedRoutes.LOGIN) === -1 &&
      global.location.pathname.indexOf(sharedRoutes.LOGOUT) === -1
    ) {
      return global.location.replace(urlWithRedirect(sharedRoutes.LOGIN, global.location.pathname));
    } else {
      return global.location.replace(urlWithRedirect(sharedRoutes.LOGIN, null));
    }
  }

  public updateAuthToken(token: AuthToken | null): void {
    useAuthenticationStore().setAuthToken(token);
  }

  public featureFlagProvider() {
    const provider = new AmplitudeFeatureFlagService();
    provider.initialize();
    return provider;
  }
}
